document.addEventListener("turbolinks:load", function () {
    const activityList = document.querySelector("#activity-list");
    const assignmentTitle =  document.querySelector("#assignment-title");
    const assignmentTitleError =  document.querySelector("#assignment-title-error");
    const nextButton = document.querySelector("#ia_continue_button");

    // Determine if this is the correct page by finding a unique element
    if (nextButton) {
        const toggleNext = () => {
            toggleIaButton(nextButton);
        }
        // Assignment Title Validation
        assignmentTitle.addEventListener("blur", () => {
            // If the string is empty or only white space, show the error. Otherwise hide it
            assignmentTitle.value.trim() === "" ? showIaError(assignmentTitleError) : hideIaError(assignmentTitleError);
            toggleNext();
        });
        // Activity Card Validation Setup
        setUpActivityCard(activityList, toggleNext);
    }
})